module.exports = __webpack_public_path__ + "static/media/11.72984a3b.jpg";